import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { useDispatch } from "react-redux";
import { auth } from "../firebaseConfig";
import { setLogin } from "../redux/slices/ui";
import Loader from "./ui/Loader";

/**
 * Real authentication gate. Subscribes to Firebase auth state and:
 *  - shows a loader while the initial auth check is in flight,
 *  - renders the protected children only when a user is signed in,
 *  - otherwise redirects to /login (preserving where the user was headed).
 */
const RequiresLogin = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [user, setUser] = useState(undefined); // undefined = still checking

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      dispatch(setLogin(!!firebaseUser));
    });
    return unsubscribe;
  }, [dispatch]);

  if (user === undefined) {
    return <Loader />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default RequiresLogin;
